const routes = {
  home: {
    path: "/",
  },
  search: {
    path: "/search",
  },
  donations: {
    path: "/donations",
  },
  donationDetails: {
    path: "/donationDetails/:donation",
  },
  portfolio: {
    path: "/portfolio/:uid",
  },
  profiles: {
    path: "/profiles",
  },
};

export default routes;
